import React, { useState, useRef, useEffect } from "react";
import styles from "../components/slides/Slidetab.module.scss";
import leftpager from "img/genai/rightpager.svg";
import rightpager from "img/genai/rightpager.svg";

const SlidePagination = ({
  currentSlide = 1,
  totalSlides = 1,
  onSlideChange,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [tempSlide, setTempSlide] = useState(currentSlide);
  const inputRef = useRef(null);

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [isEditing]);

  // Strict navigation control
  const handlePrev = () => {
    if (currentSlide > 1) {
      // Only allow if not on first slide
      onSlideChange(currentSlide - 1);
    }
  };

  const handleNext = () => {
    if (currentSlide < totalSlides) {
      // Only allow if not on last slide
      onSlideChange(currentSlide + 1);
    }
  };

  const handleInputChange = (e) => {
    const value = parseInt(e.target.value, 10);
    if (!isNaN(value)) {
      setTempSlide(value);
    }
  };

  const handleBlur = () => {
    const validatedSlide = Math.min(Math.max(tempSlide, 1), totalSlides);
    if (validatedSlide !== currentSlide) {
      onSlideChange(validatedSlide);
    }
    setIsEditing(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleBlur();
    }
  };

  const handleClick = () => {
    setIsEditing(true);
    setTempSlide(currentSlide);
  };

  // Disable states
  const isFirstSlide = currentSlide === 1;
  const isLastSlide = currentSlide === totalSlides;

  return (
    <div className={styles.slidepager}>
      {/* Previous Slide Button - Disabled on first slide */}
      <span
        onClick={handlePrev}
        style={{
          opacity: isFirstSlide ? 0.1 : 1,
          color: isFirstSlide ? "#F2F3F3" : null,
          cursor: isFirstSlide ? "default" : "pointer",
        }}
      >
        <img
          src={leftpager}
          style={{ transform: "scaleX(-1)", marginRight: "5px" }}
          alt="Previous slide"
        />
      </span>

      {/* Current Slide Display/Input */}
      {isEditing ? (
        <input
          ref={inputRef}
          type="number"
          value={tempSlide}
          onChange={handleInputChange}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
          min="1"
          max={totalSlides}
          className={styles.slideInput}
        />
      ) : (
        <span onClick={handleClick}>
          Slide{" "}
          <input
            ref={inputRef}
            type="number"
            value={currentSlide}
            onChange={handleInputChange}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
            min="1"
            max={totalSlides}
            className={styles.slideInput}
          />
        </span>
      )}

      <span> of {totalSlides}</span>

      {/* Next Slide Button - Disabled on last slide */}
      <span
        onClick={handleNext}
        style={{
          opacity: isLastSlide ? 0.1 : 1,
           color: isLastSlide ? "#F2F3F3" : null,
          cursor: isLastSlide ? "default" : "pointer",
        }}
      >
        <img src={rightpager} alt="Next slide" style={{ marginLeft: "5px" }} />
      </span>
    </div>
  );
};

export default SlidePagination;
